import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2f90d1b6"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f90d1b6')) {
      api.createRecord('2f90d1b6', component.options)
    } else {
      api.reload('2f90d1b6', component.options)
    }
    module.hot.accept("./UserDetail.vue?vue&type=template&id=2f90d1b6", function () {
      api.rerender('2f90d1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserDetail.vue"
export default component.exports